import React from "react";
import { X, Check, Plus } from "lucide-react";

// Sélecteur d'épingles : toutes les pages visibles par l'utilisateur, regroupées par section
const EpinglesPicker = ({ tree, keys, onAdd, onRemove, onClose }) => (
  <div className="opn-picker" role="dialog" aria-modal="true" aria-label="Choisir mes épingles" data-testid="epingles-picker">
    <div className="opn-picker__bg" onClick={onClose} />
    <div className="opn-picker__panel">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-lg font-bold">Mes épingles</h2>
          <p className="text-xs opacity-70">{keys.length}/8 · ce que vous ouvrez chaque matin</p>
        </div>
        <button type="button" className="opn-tool" onClick={onClose} aria-label="Fermer" data-testid="epingles-close"><X className="h-5 w-5" /></button>
      </div>
      <div className="opn-picker__grid">
        {tree.sections.map(s => (
          <div key={s.id}>
            <div className="opn-drawer__section">{s.label}</div>
            {s.pages.filter(p => !p.lien).map(p => {
              const key = `${s.path}/${p.path}`; const on = keys.includes(key); const PI = p.icon;
              return (
                <button key={p.id} type="button" className="opn-menu__item" aria-pressed={on} onClick={() => on ? onRemove(key) : onAdd(key)} data-testid={`epingle-toggle-${s.id}-${p.id}`}>
                  <PI />{p.label}
                  <span className="ml-auto">{on ? <Check className="h-4 w-4 text-emerald-400" /> : <Plus className="h-4 w-4 opacity-50" />}</span>
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default EpinglesPicker;
